import { render, staticRenderFns } from "./recordlist.vue?vue&type=template&id=0e7a9a94&"
import script from "./recordlist.vue?vue&type=script&lang=js&"
export * from "./recordlist.vue?vue&type=script&lang=js&"
import style0 from "./recordlist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports